// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__14fDo","author":"Table_author__Jfr13","authorImage":"Table_authorImage__Qs_V3","unreadRow":"Table_unreadRow__P4xC7"};